module.exports = __webpack_public_path__ + "img/workflowByActivity.1b399203.png";